//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getQuestionnaireAnswer as _getQuestionnaireAnswer } from '@/api/module/index';
export default {
  name: "index",
  data: function data() {
    return {
      answers: []
    };
  },
  created: function created() {
    this.getQuestionnaireAnswer();
  },
  methods: {
    getQuestionnaireAnswer: function getQuestionnaireAnswer() {
      var _this = this;

      var param = {
        serialno: this.$route.query.serialno
      };

      _getQuestionnaireAnswer(param).then(function (res) {
        if (res.code == 200) {
          _this.answers = res.data;
        }
      });
    }
  }
};